import { Box } from "@mui/material";
import { ReactNode } from "react";

import AppIcon from "@/common/components/Icons/AppIcon";
import AppLink from "@/common/components/Link/AppLink";
import { VehicleGenerationDto, VehicleGenerationReferenceDto } from "@/core/api/generated/v1";

import AppTooltip from "../../../Tooltip/AppTooltip";

interface Props {
  generation: VehicleGenerationDto | VehicleGenerationReferenceDto | null | undefined;
  withIcon?: boolean;
  withLink?: boolean;
  withTooltip?: boolean;
  tooltipTitle?: ReactNode;
}

export default function VehicleGenerationInline({
  generation,
  withIcon = true,
  withLink = true,
  withTooltip = false,
  tooltipTitle,
}: Props) {
  if (!generation) {
    return null;
  }

  // const full = generation as VehicleGenerationDto;
  // const ref = generation as VehicleGenerationReferenceDto;

  return (
    <AppTooltip isEnabled={withTooltip} title={tooltipTitle || "Vehicle generation"}>
      <AppLink
        // enabled={withLink}
        // to={
        //   (withLink &&
        //     ROUTE_PATH.VEHICLE_VISUAL_MODEL_VIEW({ vehicleVisualGenerationId: visualGeneration.id! })) ||
        //   ""
        // }
        isEnabled={false}
        to=''
        sx={{
          display: "inline-flex",
          alignItems: "center",
          fontSize: "inherit",
          underline: "none",
        }}
      >
        {withIcon && <AppIcon of='vehicleGeneration' inText sx={{ mr: 1 }} />}

        <Box component='span'>{generation.name}</Box>
      </AppLink>
    </AppTooltip>
  );
}
